<template>
  <section class="page-section">
    <el-card class="form-card" shadow="hover">
      <template #header>
        <div class="panel-header">
          <span>个人信息管理</span>
          <el-tag type="success">{{ roleLabel }}</el-tag>
        </div>
      </template>

      <el-form ref="profileFormRef" :model="profileForm" :rules="profileRules" label-width="100px">
        <el-form-item label="登录账号">
          <el-input :model-value="session.user.username" disabled />
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="profileForm.phone" placeholder="可选，不填写则留空" />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="profileForm.password" type="password" show-password placeholder="不修改可留空" />
        </el-form-item>
        <el-form-item label="重复新密码" prop="confirmPassword">
          <el-input
            v-model="profileForm.confirmPassword"
            type="password"
            show-password
            placeholder="请再次输入新密码"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveProfile">保存修改</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </section>
</template>

<script>
import { ElMessage } from 'element-plus'
import { saveUserProfile } from '../../services/profileService'

export default {
  name: 'ProfilePanel',
  props: {
    session: {
      type: Object,
      required: true
    },
    roleLabel: {
      type: String,
      required: true
    }
  },
  emits: ['session-updated'],
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!value && !this.profileForm.confirmPassword) {
        callback()
        return
      }

      if (!value) {
        callback(new Error('请输入新密码'))
        return
      }

      if (this.profileForm.confirmPassword && value !== this.profileForm.confirmPassword) {
        callback(new Error('两次输入的密码不一致'))
        return
      }

      callback()
    }

    const validateConfirmPassword = (rule, value, callback) => {
      if (!value && !this.profileForm.password) {
        callback()
        return
      }

      if (!value) {
        callback(new Error('请再次输入新密码'))
        return
      }

      if (value !== this.profileForm.password) {
        callback(new Error('两次输入的密码不一致'))
        return
      }

      callback()
    }

    return {
      profileForm: {
        phone: '',
        password: '',
        confirmPassword: ''
      },
      profileRules: {
        password: [{ validator: validatePassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  watch: {
    'session.user.phone': {
      immediate: true,
      handler(value) {
        this.profileForm.phone = value || ''
      }
    }
  },
  methods: {
    async saveProfile() {
      const valid = await this.$refs.profileFormRef.validate().catch(() => false)

      if (!valid) {
        return
      }

      try {
        const nextPhone = this.profileForm.phone || ''
        const nextPassword = this.profileForm.password || ''
        const passwordChanged = Boolean(nextPassword)
        const response = await saveUserProfile(nextPhone, nextPassword)
        this.profileForm.password = ''
        this.profileForm.confirmPassword = ''

        if (passwordChanged) {
          ElMessage.success('密码已修改，请重新登录')
          window.dispatchEvent(new CustomEvent('auth:logout'))
          return
        }

        ElMessage.success(response.message || response.msg || '保存成功')
        this.$emit('session-updated', {
          user: {
            ...this.session.user,
            ...(response.data || {}),
            phone: response?.data?.phone ?? nextPhone
          }
        })
      } catch (error) {
        ElMessage.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.page-section {
  display: grid;
  gap: 18px;
}

.form-card {
  border-radius: 22px;
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
</style>
